import React, { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, Typography } from "antd";
import { request, requestWithImage } from "../../../functions/request";
import { uniKey, validData } from "../../../functions/functionsUtility";
import Aguarde from "../../../components/aguarde/aguarde";
import { useNavigate } from "react-router-dom";
import { BiRightArrow, BiArrowBack } from "react-icons/bi";
import {
  AiOutlineSearch,
  AiFillEdit,
  AiFillEye,
  AiOutlinePlus,
  AiOutlinePause,
  AiFillVideoCamera,
} from "react-icons/ai";
import ModalDossieCapitulo from "../../../components/Modal/Dossie/ModalDossieCapitulo";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";
import { IoAddCircle } from "react-icons/io5";

const DossieCapitulos = () => {
  const navigate = useNavigate();
  //Modal Preview
  const [nameDossie, setNameDossie] = useState("");
  const [idDossie, setIdDossie] = useState("");
  //Modal Add
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [contentModal, setContentModal] = useState({});

  const [haveResult, setHaveResult] = useState(false);
  const [tableData, setTableData] = useState([]);

  const confirmStop = (row) => {
    confirmAlert({
      title:
        row.original.dca_ativo === 1
          ? "Você tem certeza que deseja pausar esse capítulo?"
          : "Você tem certeza que deseja ativar esse capítulo?",
      message:
        row.original.dca_ativo === 1
          ? "Este capitulo sairá do ar e não poderá ser acessados pelos usuários."
          : "Este capitulo voltará a ficar disponível para os usuários.",
      buttons: [
        {
          label: "Não",
          className: "button-delete",
          onClick: () => {},
        },
        {
          label: "Sim",
          className: "button-save",
          onClick: () => {
            const updatedRow = {
              ...row.original,
              dca_ativo: row.original.dca_ativo === 1 ? 0 : 1,
            };
            changeCapitulo(updatedRow);
          },
        },
      ],
    });
  };

  const changeCapitulo = async (row, capaImage = null) => {
    console.log(row);
    const canSave = await validData(row, [
      "dca_nome",
      "dca_ordem",
    ]);
    if (!canSave) {
      toast.error("Preencha todos os campos obrigatórios! Campo: Nome, Ordem");
      return;
    }
    try {
      const newData = JSON.stringify({ ...row, index: uniKey() });
      const formData = new FormData();
      formData.append("newData", newData);
      if (capaImage !== null) {
        formData.append("dca_capa", capaImage);
      }

      const response = await requestWithImage(
        "/dossie_capitulos/updateCapitulo/" + row.dca_id,
        {
          method: "PUT",
          body: formData,
        }
      )
        .then((res) => {
          if (res?.err) throw res.err;
          toast.success("Capítulo salvo com sucesso!");
          setIsAddOpen(false);
          fetchTableData();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Erro ao Salvar Dossiê!");
        });
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  // Recarrega a lista depois de salvar. Sem isso a tabela ficava com os
  // nomes de imagem antigos, e reabrir o mesmo capítulo e salvar de novo
  // mandava a capa antiga de volta ao banco.
  const fetchTableData = async () => {
    try {
      const id = window.location.pathname.split("/")[3];
      const urlParams = new URLSearchParams(window.location.search);
      const nomeParam = urlParams.get("nome");
      setNameDossie(nomeParam);
      const currentPathWithQuery = `/dossie_capitulos/getCapitulos?id=${id}`;
      const response = await request(currentPathWithQuery, {
        method: "GET",
      });
      setIdDossie(id);
      setTableData(response);
      setHaveResult(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "dca_ordem", //access nested data with dot notation
        header: "Ordem",
        size: 10,
      },

      {
        accessorKey: "dca_nome", //access nested data with dot notation
        header: "Nome do Capitulo",
        size: 50,
      },
      {
        accessorKey: "dca_ativo", //normal accessorKey
        header: "Ativo",
        size: 50,
        Cell: ({ cell }) =>
          cell.getValue() === 1 ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                className="active-icon"
              />
              Ativo
            </div>
          ) : cell.getValue() === 0 ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                style={{ color: "var( --gray-color)" }}
              />
              Offline
            </div>
          ) : null,
      },
    ],
    []
  );

  const openModal = async (content) => {
    try {
      setContentModal(content);
      setIsAddOpen(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  return (
    <>
      <ModalDossieCapitulo
        isAddOpen={isAddOpen}
        contentModal={contentModal}
        setContentModal={setContentModal}
        changeCapitulo={changeCapitulo}
        onSaved={fetchTableData}
        onRequestClose={() => setIsAddOpen(false)}
      />
      {haveResult ? (
        tableData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={tableData}
            enableColumnFilterModes
            enableColumnSorting
            enableRowActions
            localization={MRT_Localization_PT_BR}
            positionActionsColumn="last"
            enableRowVirtualization
            enableFacetedValues
            columnFilterModeOptions={null}
            initialState={{
              showColumnFilters: true,
              pagination: { pageIndex: 0, pageSize: 20 },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                header: "", // Altere o texto do cabeçalho, se necessário
                size: 100, // Faça a coluna de ações um pouco mais larga
              },
            }}
            renderRowActions={({ row }) => (
              <div
                style={{ display: "flex", gap: "5px", justifyContent: "end" }}
              >
                <Button
                  onClick={(el) => {
                    openModal(row.original);
                  }}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillEdit />
                  Editar
                </Button>
                <Button
                  onClick={(el) => confirmStop(row)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {row.original.dca_ativo ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <AiOutlinePause /> Pausar
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <BiRightArrow /> Ativar
                    </div>
                  )}
                </Button>
              </div>
            )}
            renderTopToolbarCustomActions={() => (
              <Content>
                <Button
                  onClick={(el) => navigate(-1)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <BiArrowBack /> Voltar
                </Button>
                <Content
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                    padding: 10,
                  }}
                >
                  <Typography.Title
                    level={4}
                    style={{
                      margin: 0,
                      display: "flex",
                      gap: 5,
                      alignItems: "center",
                    }}
                  >
                    <AiFillVideoCamera />
                    {nameDossie ? "Dossiê: " + nameDossie : "Dossiê"}
                  </Typography.Title>
                  <Button
                    type="primary"
                    icon={<IoAddCircle />}
                    onClick={(el) => {
                      setContentModal({ dca_dossie_id: idDossie });
                      setIsAddOpen(true);
                    }}
                  >
                    Adicionar Capítulo
                  </Button>
                </Content>
              </Content>
            )}
            muiTableHeadCellFilterTextFieldProps={{
              placeholder: "Filtrar",
            }}
          />
        ) : (
          <div>
            <Content>
              <Button
                onClick={(el) => navigate(-1)}
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <BiArrowBack /> Voltar
              </Button>
              <Content
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                  padding: 10,
                }}
              >
                <Typography.Title
                  level={4}
                  style={{
                    margin: 0,
                    display: "flex",
                    gap: 5,
                    alignItems: "center",
                  }}
                >
                  <AiFillVideoCamera />
                  {nameDossie ? "Dossiê: " + nameDossie : "Dossiê"}
                </Typography.Title>
                <Button
                  type="primary"
                  icon={<IoAddCircle />}
                  onClick={(el) => {
                    setContentModal({ dca_dossie_id: idDossie });
                    setIsAddOpen(true);
                  }}
                >
                  Adicionar Capítulo
                </Button>
              </Content>
            </Content>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60%",
                paddingTop: 40,
              }}
            >
              <h2>Nenhum capítulo cadastrado.</h2>
              <AiOutlineSearch size={48} color="#888" />
              <p>Clique em "Adicionar Capítulo" para começar.</p>
            </div>
          </div>
        )
      ) : (
        <Aguarde />
      )}
    </>
  );
};

export default DossieCapitulos;
